const currentSrc = document.currentScript.src;
(function ($) {
	//全站蓋板 COOKIE宣告---START
	var Announcesetting = null;
	$.fn.cookiesAnnounce = function (options) {

		const cookieExistDays = 30;

		Announcesetting = $.extend(true, {
			// These are the defaults.
			afterclose: null, //關閉視窗後執行的function
			css: {//調整視窗樣式
				color: "#ffffff",//字體顏色
				background: "#000000E6",//背景
				closeSrc: "https://www.gigabyte.com/Images/Object/CheckMarkWhite.svg",//右上角X按鈕圖檔URL
				closesrcOpacity: 1//右上角X按鈕圖檔透明度
			},
			countryCode: getCountryCode(),
		}, options);


		this.append(Announcesettext(Announcesetting.css));

		//呼叫視窗顯示
		ShowPolicyDiv();

		//偵測關閉視窗
		$(document).on('click', '#policy-close', function () {
			$("#policy-div").slideUp(350);

			// 塞入 cookie
			const date = new Date();
			date.setTime(date.getTime() + cookieExistDays * (24 * 60 * 60 * 1000));
			const cookieString = `HasPolicyClosed_${Announcesetting.countryCode}=1;domain=gigabyte.com;expires=${date.toGMTString()};path=/`;
			document.cookie = cookieString;

			//若傳入值具備此變數，且此變數為FUNCTION 型態，在關閉後執行此FUNCTION
			if (Announcesetting.afterclose !== null && typeof (Announcesetting.afterclose) == "function") {
				Announcesetting.afterclose();
			}
		});

		var policyCloseTarget = $('#policy-close');
		$(window).resize(function () {
			if ($(window).width() > 960) {
				policyCloseTarget.children().css("filter", "opacity(0.5)");
			} else {
				policyCloseTarget.children().css("filter", "opacity(1)");
			}
		});

		policyCloseTarget.hover(
			function () {
				$(this).children().css("filter", "opacity(1)");
			}, function () {
				$(this).children().css("filter", "opacity(0.5)");
			}
		);

		/* 依引用情境回傳 country code
		 * 1. 官網內引用：使用 CountryCode變數
		 * 2. 外站引用：判斷引用是否帶入 querystring
		 * 3.預設回傳 global
		*/
		function getCountryCode() {
			if ((typeof window.CountryCode) !== 'undefined') {
				return window.CountryCode;
			}
			const searchParam = new URLSearchParams(new URL(currentSrc).search);
			if (searchParam.has('countryCode')) {
				return searchParam.get('countryCode');
			}
			return 'global';
		}
	};

	//依序建造出顯示視窗的HTML
	var Announcesettext = function (css) {
		var policy = $("<div></div>");
		policy.attr("id", "policy-div");
		policy.css("width", "100%");
		policy.css("z-index", "100002");
		policy.css("display", "none");
		//依照輸入的背景顏色改變背景顏色
		policy.css("background", css.background);
		var policysub = $("<div></div>");
		policysub.addClass("policy-div-sub");
		policysub.css("width", "90%");
		policysub.css("margin", "0px auto");
		policysub.css("padding", "1.2vw 0px");
		//		policysub.css("position", "relative");
		policysub.css("display", "inline-flex");
		policysub.css("max-width", "87%");
		var contentSpan = $("<div></div>");
		contentSpan.addClass("policy-div-txt");
		contentSpan.css("line-height", "1.5vw");
		policysub.css("margin", "0 2% 0 5%");
		//依照輸入的顏色改變字體顏色
		contentSpan.css("color", css.color);

		const privacyPolicyUrl = getPrivacyPolicyUrl();
		const cookieAnnounceMsg = `This website uses cookies to provide you a more personalized and responsive service. By using this website you agree to our use of cookies. If you require more information or prefer not to accept cookies please visit our <a target="_blank" href="${privacyPolicyUrl}">Privacy Policy</a>.`
		contentSpan.html($("<div></div>").html(cookieAnnounceMsg));

		contentSpan.find("a").css("color", css.color);
		contentSpan.find("a").css("text-decoration", "underline");
		policysub.append(contentSpan);
		policy.append(policysub);
		var close = $("<div></div>");
		close.attr("id", "policy-close");
		close.css("position", "absolute");
		close.css("right", "3%");
		close.css("cursor", "pointer");
		close.css("margin-left", "-5%");
		close.css("min-width", "3.4vw");
		close.css("height", "100%");
		close.css("top", "0");
		var img = $("<img />");
		img.attr("src", css.closeSrc);
		img.css("max-width", "3.4vw");
		img.css("height", "100%");
		img.css("opacity", css.closesrcOpacity);
		img.css("filter", "opacity(0.5)");
		close.append(img);
		policysub.append(close);
		return policy;

	}

	function getPrivacyPolicyUrl() {
        const hostname = window.location.hostname;

		if (hostname.includes('.gigabyte.')) {
			if (Announcesetting.countryCode === 'cn') {
				return '/Privacy-Policy';
            }
			return `${window.UrlCountryCode}/Privacy-Policy`;
		} else {
            if (Announcesetting.countryCode === 'cn') {
				return 'https://profile.gigabyte.com/PrivacyPolicy.aspx?l=zh-CN';
			} else {
				const countryCode = Announcesetting.countryCode === 'global' ? '' : `/${Announcesetting.countryCode}`;
				return `https://www.gigabyte.com${countryCode}/Privacy-Policy`;
			}
		}
    }

    var ShowPolicyDiv = function () {
		let checkCookie = "HasPolicyClosed_" + Announcesetting.countryCode;

		if (!document.cookie.includes(checkCookie)) {
			//視窗顯示
			$("#policy-div").slideDown(350);
		}

	};
	//全站蓋板 COOKIE宣告---End
}(jQuery));